import { Button, Card, Col, Container, Row } from "react-bootstrap";
import CoursePlan from "../../docs/RDL780CoursePlan.pdf";
import Background from "../../image/background2.jpg";

export default function Entrepreneurship() {
    return(        
    <>
        <Container fluid style={{background: "url(" + Background + ") no-repeat fixed center"}}>
        <Container>
            <Row className="justify-content-center section">
                <Col md="8" sm="12" className="image-over-section">
                    <h2 style={{textAlign:"center"}}>Rural Innovation and Entrepreneurship (RDL780)</h2>
                    <p style={{textAlign:"center"}}>This course provides learners with deep insights about Rural Innovation and Entrepreneurship. Based on diverse ground experiences, the course provides a comprehensive knowledge of the rural entrepreneurial ecosystem in diverse cultural contexts. The course amplifies students’ innate ability to think beyond textbook concepts and enables them to explore development of innovative pathways to deliver products, services and systems for rural communities. It also encourages cultivation of Design Thinking and Frugal Innovation Mindset resulting in Innovative Business Models that can organically flourish in the rural context.</p>
                    <Button href={CoursePlan} target="_blank">Course plan <i className="bi bi-box-arrow-up-right"></i></Button>
                </Col>
            </Row>
        </Container>
        </Container>

        <Container className="section">
                <h2>Course Structure</h2>
            <Row xs="1" sm="3" md="3">
                <Col>
                    <Card className="publications-list module">
                        <Card.Header>MODULE 1 : Introduction to Rural Innovation and Entrepreneurship</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <ul>
                                    <li>Rural Innovation Ecosystem</li>
                                    <li>Rural Business Overview</li>
                                    <li>Facets of Rural Entrepreneurship</li>
                                </ul>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>

                <Col>
                    <Card className="publications-list module">
                        <Card.Header>MODULE 2 : Understanding the Rural Entrepreneurial Ecosystem</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <ul>
                                    <li>Critical Attributes for Rural Entrepreneurs</li>
                                    <li>The Technology and Economic Context for Rural Enterprises</li>
                                    <li>Team Building in a Rural Scenario</li>
                                </ul>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col>
                    <Card className="publications-list module">
                        <Card.Header>MODULE 3 : Frugal Innovations and Grassroots Entrepreneurship</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <ul>
                                    <li>Examples of Frugal Innovations</li>
                                    <li>Technology Acceptance Model & Rural Innovations</li>
                                    <li>Grassroot Entrepreneurship & the Technology Diffusion Model</li>
                                </ul>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>

                <Col>
                    <Card className="publications-list module">
                        <Card.Header>MODULE 4 :Challenges in Rural Entrepreneurship & Learnings from Failures</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <ul>
                                    <li>Case Study of Rural Sanitation</li>
                                    <li>Case Study of Rural Health</li>
                                    <li>Case Study of Rural Housing</li>
                                </ul>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>

                <Col>
                    <Card className="publications-list module">
                        <Card.Header>MODULE 5 : Sustainable Business Models in Rural Entrepreneurship</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <ul>
                                    <li>Developing creative and community solutions to address social issues</li>
                                    <li>Understanding Sustainable Business Models in practice</li>
                                    <li>Ideation, Prototyping, Testing &Validation</li>
                                </ul>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>

                <Col>
                    <Card className="publications-list module">
                        <Card.Header>MODULE 6 : Design Thinking and Entrepreneurship</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <ul>
                                    <li>Understanding the role of Design thinking for Rural Enterprises</li>
                                    <li>Tools & Frameworks of Human-Centered Design</li>
                                    <li>Uncovering latent needs & expectations of Customer / User Needs</li>
                                    <li>Ethnography & Mental Models to understand Rural Market</li>
                                </ul>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>

                <Col>
                    <Card className="publications-list module">
                        <Card.Header>MODULE 7 : Cross-Cultural Learnings in Rural Entrepreneurship</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <ul>
                                    <li>Learnings from African Experiences</li>
                                    <li>Learnings from South American Experiences</li>
                                </ul>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>

                <Col>
                    <Card className="publications-list module">
                        <Card.Header>MODULE 8 : Success Stories of Rural Entrepreneurship</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <ul>
                                    <li>Agricultural enterprises</li>
                                    <li>Forest and Women-led enterprises</li>
                                    <li>Artisanal enterprises</li>
                                    <li>Reflections & Learnings from Unsuccesful Attempts</li>
                                </ul>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>

                <Col>
                    <Card className="publications-list module">
                        <Card.Header>MODULE 9 : Building a Rural Enterprise Strategically
                        </Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <ul>
                                    <li>Setting up a Rural Enterprise</li>
                                    <li>Using a Lean Canvas & Developing Business Plan</li>
                                    <li>Storytelling and Impactful Pitch Decks</li>
                                </ul>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>

                <Col>
                    <Card className="publications-list module">
                        <Card.Header>MODULE 10 : Growing and Sustaining Rural Enterprises</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <ul>
                                    <li>Creating Impact through Partnerships</li>
                                    <li>Leveraging on support from Rural Business Incubators</li>
                                    <li>Grants, Equity, Seed fund, Angel Investors, Crowdfunding</li>
                                    <li>Scaling Up</li>
                                </ul>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>  
            </Row>
        </Container>
        </>
    )
}